import { StyleSheet } from "react-native"
import { colors, typography } from "theme"

export const style = StyleSheet.create({
  container: { height: "100%", padding: 10 },
  contentText: { fontFamily: typography.primary.normal, marginBottom: 10 },
  contentView: {
    borderColor: colors.linearFirstColor,
    borderRadius: 10,
    borderWidth: 0.5,
    marginBottom: 20,
    padding: 20,
  },
  emptyContainer: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
  emptyTitle: {
    fontFamily: typography.primary.normal,
    fontSize: 25,
    padding: 20,
    textAlign: "center",
  },
  flex: {
    flex: 1,
  },
  text: { fontFamily: typography.primary.normal },
  titleText: {
    fontFamily: typography.primary.normal,
    fontSize: 23,
    marginTop: 40,
  },
})
